module.exports = __webpack_public_path__ + "img/schilderwerken.9cd74749.jpg";